<template>
  <div class="text-left">
    <!-- <span v-if="value.includes('http')" @click="showBigImage">
      <qrcode-vue :value="value" :size="size" level="L"></qrcode-vue>
    </span>
    <span v-else>{{ value }}</span> -->

    <v-icon color="primary" class="cursor-pointer mx-2" @click="copyText(value)">
      mdi-content-copy
    </v-icon>

    <v-icon
      v-if="value.includes('http')"
      color="error"
      @click="showBigImage"
      class="cursor-pointer"
    >
      mdi-qrcode
    </v-icon>
    <!-- <span v-else>{{ value }}</span> -->

    <v-dialog
      v-if="imageDialog"
      v-model="imageDialog"
      max-width="300px"
      content-class="no-shadow-dialog"
    >
      <div>
        <qrcode-vue :value="value" :size="300" level="L"></qrcode-vue>
      </div>
      <!-- <div class="primary--text">
        {{ value }}
      </div> -->
    </v-dialog>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  name: "QrLink",
  components: {
    QrcodeVue,
  },
  data: () => ({
    imageDialog: false,
  }),
  props: {
    value: {
      type: String,
      default: () => "",
    },
    size: {
      type: Number,
      default: () => 50,
    },
  },
  methods: {
    showBigImage() {
      this.imageDialog = true;
    },
  },
};
</script>

<style scoped></style>
